import React, { useEffect, useState } from "react";
import "./LineDesign.css";
import { lineDesign } from "../../config/images";
import { getDeviceTagByType } from "../VMS/VmsCompanyDashboard/VmsMachine/service";
import Mqqtdata from "../ProcessDashboard/Mqqtdata";
import { SoftTagFormula } from "../SmartTag/softTag/SoftTagFormula";
import { getPlantByID } from "../SuperAdminDashboard/service";
import { getDeviceTagByTypeNew } from "../ProcessDashboard/service";

const meters = [
  { id: 1, label: "F1 O/G 100A" },
  { id: 2, label: "F1 O/G 125A" },
  { id: 3, label: "F1 O/G 125A" },
  { id: 4, label: "F1 O/G 125A" },
  { id: 5, label: "F1 O/G 200A" },
];
const meters1 = [
  { id: 1, label: "F11 O/G 100A" },
  { id: 2, label: "F11 O/G 125A" },
  { id: 3, label: "F11 O/G 125A" },
  { id: 4, label: "F11 O/G 200A" },
];

const metersData2 = [
  [{ id: 1, label: "F2 O/G 400A", direction: "upward" }],
  [
    { id: 2, label: "F2 O/G 630A", direction: "upward" },
    { id: 3, label: "DG-1", direction: "downward" },
  ],
  [{ id: 4, label: "F2 O/G 1250A", direction: "upward" }],
  [
    { id: 5, label: "F3 O/G 2000A", direction: "upward" },
    { id: 6, label: "GEB-1", direction: "downward" },
  ],
  [{ id: 7, label: "F9 O/G 2000A", direction: "upward" }],
  [
    { id: 8, label: "F10 O/G 400A", direction: "upward" },
    { id: 9, label: "GEB-2", direction: "downward" },
  ],
  [{ id: 10, label: "F10 O/G 630A", direction: "upward" }],
  [
    { id: 11, label: "F10 O/G 1250A", direction: "upward" },
    { id: 12, label: "DG-2", direction: "downward" },
  ],
];

const LineDesign = ({ deviceIds }) => {
  const [activePage, setActivePage] = useState(0);
  const [deviceData, setDeviceData] = useState([]);
  const [mqttTagData, setMqttTagData] = useState();

  const [topics, setTopics] = useState([]);

  const mergedArray = mqttTagData
    ? [].concat(...Object.values(mqttTagData))
    : [];

  const mqttDataReduce = mergedArray.reduce((map, item) => {
    map[item.device_tag] = Number(item.tagValue);
    return map;
  }, {});

  useEffect(() => {
    if (deviceData.length) {
      const topicArray = deviceData.flatMap(
        (plant) => "Hikar/DeviceUID/" + plant.device__uid
      );

      setTopics(topicArray);
    }
  }, [deviceData]);

  const handleNextClick = () => {
    setActivePage((prevPage) => (prevPage === 2 ? 0 : prevPage + 1));
  };

  const handlePreviousClick = () => {
    setActivePage((prevPage) => (prevPage === 0 ? 2 : prevPage - 1));
  };

  useEffect(() => {
    handleCallAPI();
  }, [deviceIds]);

  const handleCallAPI = async () => {
    const params = {
      company_id: 145,
      device_id: deviceIds.map((e) => e.id),
      plant_id: 110,
    };
    try {
      const resp = await getDeviceTagByTypeNew(params);
      if (resp.status == 200 || resp.status == 201) {
        setDeviceData(resp.data.payload);
      }
    } catch (error) {
      setDeviceData([]);
    }
  };

  const shouldBreak = (index) => {
    const breakPoints = [3, 6]; // Break after the 4th and 7th element
    return breakPoints.includes(index);
  };

  return (
    <>
      {topics.length ? (
        <Mqqtdata topics={topics} setMqttTagData={setMqttTagData} />
      ) : null}

      <div className="line-data">
        <div className="main-content">
          {activePage !== 0 && (
            <img
              src={lineDesign.leftArrowIcon}
              alt="left-arrow"
              className="left-arrow"
              onClick={() => handlePreviousClick()}
            />
          )}
          {activePage == 0 && (
            <div className="busbar2">
              {meters.map((meter, index) => (
                <div key={index} className="connection-point">
                  <img
                    src={lineDesign.dotIcon}
                    alt="dot-icon"
                    className="dot"
                  />
                  <div className="vertical-line"></div>

                  {meter.label == "F1 O/G 100A" &&
                    deviceData
                      .filter((e) => e.id == 377)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_1F1_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_1F1_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = lineDesign.crossRedIcon;
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = lineDesign.crossIcon;
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = lineDesign.crossRedIcon;
                          }

                          return (
                            <img src={appliedClass} alt="" className="cross" />
                          );
                        })
                      )}
                  {meter.label == "F1 O/G 125A" &&
                    meter.id == 2 &&
                    deviceData
                      .filter((e) => e.id == 378)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let appliedClass = "";

                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_1F2_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_1F2_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = lineDesign.crossRedIcon;
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = lineDesign.crossIcon;
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = lineDesign.crossRedIcon;
                          }

                          return (
                            <img src={appliedClass} alt="" className="cross" />
                          );
                        })
                      )}

                  {meter.label == "F1 O/G 125A" &&
                    meter.id == 3 &&
                    deviceData
                      .filter((e) => e.id == 379)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                                (f) =>
                                  f.device__uid == tags.device__uid &&
                                  f.device_tag == tags.device_tag
                              )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_1F3_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_1F3_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = lineDesign.crossRedIcon;
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = lineDesign.crossIcon;
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = lineDesign.crossRedIcon;
                          }

                          return (
                            <img src={appliedClass} alt="" className="cross" />
                          );
                        })
                      )}
                  {meter.label == "F1 O/G 125A" &&
                    meter.id == 4 &&
                    deviceData
                      .filter((e) => e.id == 380)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                                (f) =>
                                  f.device__uid == tags.device__uid &&
                                  f.device_tag == tags.device_tag
                              )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_1F4_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_1F4_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = lineDesign.crossRedIcon;
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = lineDesign.crossIcon;
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = lineDesign.crossRedIcon;
                          }

                          return (
                            <img src={appliedClass} alt="" className="cross" />
                          );
                        })
                      )}

                  {meter.label == "F1 O/G 200A" &&
                    deviceData
                      .filter((e) => e.id == 381)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                                (f) =>
                                  f.device__uid == tags.device__uid &&
                                  f.device_tag == tags.device_tag
                              )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";

                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_1F5_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_1F5_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = lineDesign.crossRedIcon;
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = lineDesign.crossIcon;
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = lineDesign.crossRedIcon;
                          }

                          return (
                            <img src={appliedClass} alt="" className="cross" />
                          );
                        })
                      )}

                  {meter.label == "F1 O/G 100A" &&
                    deviceData
                      .filter((e) => e.id == 377)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let appliedClass = "";

                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_1F1_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_1F1_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = "diagonal-line-off-upward";
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = "diagonal-line";
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = "diagonal-line-green";
                          }

                          return <div className={appliedClass}></div>;
                        })
                      )}
                  {meter.label == "F1 O/G 125A" &&
                    meter.id == 2 &&
                    deviceData
                      .filter((e) => e.id == 378)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                                (f) =>
                                  f.device__uid == tags.device__uid &&
                                  f.device_tag == tags.device_tag
                              )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_1F2_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_1F2_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = "diagonal-line-off-upward";
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = "diagonal-line";
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = "diagonal-line-green";
                          }

                          return <div className={appliedClass}></div>;
                        })
                      )}
                  {meter.label == "F1 O/G 125A" &&
                    meter.id == 3 &&
                    deviceData
                      .filter((e) => e.id == 379)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                                (f) =>
                                  f.device__uid == tags.device__uid &&
                                  f.device_tag == tags.device_tag
                              )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_1F3_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_1F3_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = "diagonal-line-off-upward";
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = "diagonal-line";
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = "diagonal-line-green";
                          }

                          return <div className={appliedClass}></div>;
                        })
                      )}
                  {meter.label == "F1 O/G 125A" &&
                    meter.id == 4 &&
                    deviceData
                      .filter((e) => e.id == 380)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                                (f) =>
                                  f.device__uid == tags.device__uid &&
                                  f.device_tag == tags.device_tag
                              )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_1F4_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_1F4_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = "diagonal-line-off-upward";
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = "diagonal-line";
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = "diagonal-line-green";
                          }

                          return <div className={appliedClass}></div>;
                        })
                      )}
                  {meter.label == "F1 O/G 200A" &&
                    deviceData
                      .filter((e) => e.id == 381)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                                (f) =>
                                  f.device__uid == tags.device__uid &&
                                  f.device_tag == tags.device_tag
                              )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_1F5_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_1F5_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = "diagonal-line-off-upward";
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = "diagonal-line";
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = "diagonal-line-green";
                          }

                          return <div className={appliedClass}></div>;
                        })
                      )}
                  {/* <div className="diagonal-line"></div> */}
                  <div className="meter-unit">
                    <div className="meter-box">
                      <div className="meter-label">{meter.label}</div>
                      <img src={lineDesign.meterBox} alt="meter-icon" />
                      <div className="horizontal-line"></div>
                    </div>
                    <div className="meter-info">
                      <div className="meter-values">
                        {meter.label === "F1 O/G 100A" &&
                          deviceData
                            .filter((e) => e.id == 377)
                            .map((e) =>
                              e.tags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                  : 0.0;

                                if (
                                  tags.is_soft_tag &&
                                  tags.soft_tag_id__formula &&
                                  Object.keys(mqttDataReduce).length
                                ) {
                                  if (
                                    SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag === true
                                  ) {
                                    tagValue = SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.value;
                                  }
                                }

                                const unitLabels = {
                                  V: "VLL",
                                  A: "LN",
                                  PF: "QA",
                                  KW: "KT",
                                  KVAR: "KV",
                                  KVA: "KA",
                                };

                                const tagUnitUpper = tags.tag_unit
                                  ? tags.tag_unit.trim().toUpperCase()
                                  : "";

                                if (unitLabels[tagUnitUpper]) {
                                  return (
                                    <p key={tags.id}>
                                      <span>
                                        {unitLabels[tagUnitUpper]} (
                                        {tags.tag_unit}):
                                      </span>{" "}
                                      {tagValue}
                                    </p>
                                  );
                                }

                                return null;
                              })
                            )}
                        {meter.label === "F1 O/G 125A" &&
                          meter.id == 2 &&
                          deviceData
                            .filter((e) => e.id == 378)
                            .map((e) =>
                              e.tags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                  : 0.0;

                                if (
                                  tags.is_soft_tag &&
                                  tags.soft_tag_id__formula &&
                                  Object.keys(mqttDataReduce).length
                                ) {
                                  if (
                                    SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag === true
                                  ) {
                                    tagValue = SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.value;
                                  }
                                }

                                if (
                                  [
                                    "V",
                                    "A",
                                    "PF",
                                    "KW",
                                    "KVAR",
                                    "KVA",
                                  ].includes(tags.tag_unit.toUpperCase())
                                ) {
                                  let label = "";

                                  switch (tags.tag_unit.toUpperCase()) {
                                    case "V":
                                      label = "VLL";
                                      break;
                                    case "A":
                                      label = "LN"; // No change needed
                                      break;
                                    case "PF":
                                      label = "QA";
                                      break;
                                    case "KW":
                                      label = "KT";
                                      break;
                                    case "KVAR":
                                      label = "KV";
                                      break;
                                    case "KVA":
                                      label = "KA";
                                      break;
                                    default:
                                      label = "";
                                  }

                                  return (
                                    <p key={tags.id}>
                                      <span>
                                        {label} ({tags.tag_unit}):
                                      </span>{" "}
                                      {tagValue}
                                    </p>
                                  );
                                }

                                return null;
                              })
                            )}
                        {meter.label === "F1 O/G 125A" &&
                          meter.id == 3 &&
                          deviceData
                            .filter((e) => e.id == 379)
                            .map((e) =>
                              e.tags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                  : 0.0;

                                if (
                                  tags.is_soft_tag &&
                                  tags.soft_tag_id__formula &&
                                  Object.keys(mqttDataReduce).length
                                ) {
                                  if (
                                    SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag === true
                                  ) {
                                    tagValue = SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.value;
                                  }
                                }

                                if (
                                  [
                                    "V",
                                    "A",
                                    "PF",
                                    "KW",
                                    "KVAR",
                                    "KVA",
                                  ].includes(tags.tag_unit.toUpperCase())
                                ) {
                                  let label = "";
                                  switch (tags.tag_unit.toUpperCase()) {
                                    case "V":
                                      label = "VLL";
                                      break;
                                    case "A":
                                      label = "LN"; // No change needed
                                      break;
                                    case "PF":
                                      label = "QA";
                                      break;
                                    case "KW":
                                      label = "KT";
                                      break;
                                    case "KVAR":
                                      label = "KV";
                                      break;
                                    case "KVA":
                                      label = "KA";
                                      break;
                                    default:
                                      label = "";
                                  }

                                  return (
                                    <p key={tags.id}>
                                      <span>
                                        {label} ({tags.tag_unit}):
                                      </span>{" "}
                                      {tagValue}
                                    </p>
                                  );
                                }

                                return null;
                              })
                            )}
                        {meter.label === "F1 O/G 125A" &&
                          meter.id == 4 &&
                          deviceData
                            .filter((e) => e.id == 380)
                            .map((e) =>
                              e.tags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                  : 0.0;

                                if (
                                  tags.is_soft_tag &&
                                  tags.soft_tag_id__formula &&
                                  Object.keys(mqttDataReduce).length
                                ) {
                                  if (
                                    SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag === true
                                  ) {
                                    tagValue = SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.value;
                                  }
                                }

                                if (
                                  [
                                    "V",
                                    "A",
                                    "PF",
                                    "KW",
                                    "KVAR",
                                    "KVA",
                                  ].includes(tags.tag_unit.toUpperCase())
                                ) {
                                  let label = "";

                                  switch (tags.tag_unit.toUpperCase()) {
                                    case "V":
                                      label = "VLL";
                                      break;
                                    case "A":
                                      label = "LN"; // No change needed
                                      break;
                                    case "PF":
                                      label = "QA";
                                      break;
                                    case "KW":
                                      label = "KT";
                                      break;
                                    case "KVAR":
                                      label = "KV";
                                      break;
                                    case "KVA":
                                      label = "KA";
                                      break;
                                    default:
                                      label = "";
                                  }

                                  return (
                                    <p key={tags.id}>
                                      <span>
                                        {label} ({tags.tag_unit}):
                                      </span>{" "}
                                      {tagValue}
                                    </p>
                                  );
                                }

                                return null;
                              })
                            )}
                        {meter.label === "F1 O/G 200A" &&
                          deviceData
                            .filter((e) => e.id == 381)
                            .map((e) =>
                              e.tags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                  : 0.0;

                                if (
                                  tags.is_soft_tag &&
                                  tags.soft_tag_id__formula &&
                                  Object.keys(mqttDataReduce).length
                                ) {
                                  if (
                                    SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag === true
                                  ) {
                                    tagValue = SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.value;
                                  }
                                }

                                if (
                                  [
                                    "V",
                                    "A",
                                    "PF",
                                    "KW",
                                    "KVAR",
                                    "KVA",
                                  ].includes(tags.tag_unit.toUpperCase())
                                ) {
                                  let label = "";

                                  switch (tags.tag_unit.toUpperCase()) {
                                    case "V":
                                      label = "VLL";
                                      break;
                                    case "A":
                                      label = "LN"; // No change needed
                                      break;
                                    case "PF":
                                      label = "QA";
                                      break;
                                    case "KW":
                                      label = "KT";
                                      break;
                                    case "KVAR":
                                      label = "KV";
                                      break;
                                    case "KVA":
                                      label = "KA";
                                      break;
                                    default:
                                      label = "";
                                  }
                                  return (
                                    <p key={tags.id}>
                                      <span>
                                        {label} ({tags.tag_unit}):
                                      </span>{" "}
                                      {tagValue}
                                    </p>
                                  );
                                }

                                return null;
                              })
                            )}
                      </div>
                    </div>
                  </div>
                  <div className="vertical-line-to-meter"></div>
                </div>
              ))}
            </div>
          )}

          {activePage == 1 && (
            <>
              <div className="busbar00">
                {metersData2.map((meterArray, index) => {
                  return (
                    <div
                      key={index}
                      // className={`connection-point ${shouldBreak(index) ? "break-busbar" : ""}`}
                      className="connection-point"
                    >
                      {index == 3 && (
                        <>
                          {deviceData
                            .filter((e) => e.id == 392)
                            .map((e) =>
                              e.tags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == e.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                  : 0.0;

                                let appliedClass = "";
                                const tripTag = mergedArray.find(
                                  (f) =>
                                    f.device__uid == tags.device__uid &&
                                    f.device_tag == "P_BC_TRIP_FB"
                                );
                                const onTag = mergedArray.find(
                                  (f) =>
                                    f.device__uid === tags.device__uid &&
                                    f.device_tag == "P_BC_ON_FB"
                                );

                                const offTag = mergedArray.find(
                                  (f) =>
                                    f.device__uid === tags.device__uid &&
                                    f.device_tag == "P_BC_OFF_FB"
                                );
                                const tripValue = tripTag
                                  ? Number(tripTag["tagValue"])
                                  : 0;
                                const onValue = onTag
                                  ? Number(onTag["tagValue"])
                                  : 0;
                                const offValue = offTag
                                  ? Number(offTag["tagValue"])
                                  : 0;

                                if (
                                  tripValue == 0 &&
                                  onValue == 1 &&
                                  offValue == 0
                                ) {
                                  appliedClass = lineDesign.crossRedIcon;
                                } else if (
                                  tripValue == 1 &&
                                  onValue == 0 &&
                                  offValue == 0
                                ) {
                                  appliedClass = lineDesign.crossIcon;
                                } else if (
                                  tripValue == 0 &&
                                  onValue == 0 &&
                                  offValue == 1
                                ) {
                                  appliedClass = lineDesign.crossRedIcon;
                                } else if (
                                  tripValue == 0 &&
                                  onValue == 0 &&
                                  offValue == 0
                                ) {
                                  appliedClass = lineDesign.crossRedIcon;
                                }

                                return (
                                  <>
                                    <img
                                      src={appliedClass}
                                      alt=""
                                      className="crossdefault"
                                    />
                                  </>
                                );
                              })
                            )}
                          {deviceData
                            .filter((e) => e.id == 392)
                            .map((e, index) =>
                              e.tags.map((tags, i) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                  : 0.0;

                                let appliedClass = "";

                                // if (
                                //   (["BC_OFF_FB", "BC_TRIP_FB", "BC_ON_FB"].includes(tags.tag_name) &&
                                //     tagValue == 0.0) ||
                                //   tagValue == 0
                                // ) {

                                //   appliedClass = "diagonal-line-off";
                                // } else

                                const tripTag = mergedArray.find(
                                  (f) =>
                                    f.device__uid == tags.device__uid &&
                                    f.device_tag == "P_BC_TRIP_FB"
                                );
                                const onTag = mergedArray.find(
                                  (f) =>
                                    f.device__uid === tags.device__uid &&
                                    f.device_tag == "P_BC_ON_FB"
                                );

                                const offTag = mergedArray.find(
                                  (f) =>
                                    f.device__uid === tags.device__uid &&
                                    f.device_tag == "P_BC_OFF_FB"
                                );
                                const tripValue = tripTag
                                  ? Number(tripTag["tagValue"])
                                  : 0;
                                const onValue = onTag
                                  ? Number(onTag["tagValue"])
                                  : 0;
                                const offValue = offTag
                                  ? Number(offTag["tagValue"])
                                  : 0;

                                if (
                                  tripValue == 0 &&
                                  onValue == 1 &&
                                  offValue == 0
                                ) {
                                  appliedClass = "default-line-on";
                                } else if (
                                  tripValue == 1 &&
                                  onValue == 0 &&
                                  offValue == 0
                                ) {
                                  appliedClass = "default-line";
                                } else if (
                                  tripValue == 0 &&
                                  onValue == 0 &&
                                  offValue == 1
                                ) {
                                  appliedClass = "default-line-green";
                                } else if (
                                  tripValue == 0 &&
                                  onValue == 0 &&
                                  offValue == 0
                                ) {
                                  appliedClass = "default-line-green";
                                }

                                return (
                                  <>
                                    <div className={appliedClass}></div>
                                  </>
                                );
                              })
                            )}
                        </>
                      )}
                      {meterArray.map((item, itemIndex) => (
                        <React.Fragment key={itemIndex}>
                          {meterArray.length == 2 &&
                            item.label == "F2 O/G 630A" &&
                            deviceData
                              .filter((e) => e.id == 372)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == e.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";

                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_DG_1_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_DG_1_ON_FB"
                                  );

                                  const offTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_DG_1_OFF_FB"
                                  );
                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;
                                  const offValue = offTag
                                    ? Number(offTag["tagValue"])
                                    : 0;

                                  if (
                                    tripValue == 0 &&
                                    onValue == 1 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line-on";
                                  } else if (
                                    tripValue == 1 &&
                                    onValue == 0 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line1";
                                  } else if (
                                    tripValue == 0 &&
                                    onValue == 0 &&
                                    offValue == 1
                                  ) {
                                    appliedClass = "diagonal-line-off";
                                  } else if (
                                    tripValue == 0 &&
                                    onValue == 0 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line-off";
                                  }

                                  return (
                                    <>
                                      <div className={appliedClass}></div>

                                      <div
                                        className="vertical-line"
                                        style={{ top: "-28px" }}
                                      ></div>
                                    </>
                                  );
                                })
                              )}
                          {meterArray.length == 2 &&
                            item.label == "F3 O/G 2000A" &&
                            deviceData
                              .filter((e) => e.id == 371)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == e.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";

                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_GEB_1_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_GEB_1_ON_FB"
                                  );

                                  const offTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_GEB_1_OFF_FB"
                                  );
                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;
                                  const offValue = onTag
                                    ? Number(offTag["tagValue"])
                                    : 0;

                                  if (
                                    tripValue == 0 &&
                                    onValue == 1 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line-on";
                                  } else if (
                                    tripValue == 1 &&
                                    onValue == 0 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line1";
                                  } else if (
                                    tripValue == 0 &&
                                    onValue == 0 &&
                                    offValue == 1
                                  ) {
                                    appliedClass = "diagonal-line-off";
                                  } else if (
                                    tripValue == 0 &&
                                    onValue == 0 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line-off";
                                  }

                                  return (
                                    <>
                                      <div className={appliedClass}></div>

                                      <div
                                        className="vertical-line"
                                        style={{ top: "-28px" }}
                                      ></div>
                                    </>
                                  );
                                })
                              )}
                          {meterArray.length == 2 &&
                            item.label == "F10 O/G 400A" &&
                            deviceData
                              .filter((e) => e.id == 382)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == e.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                    : 0.0;
                                  let appliedClass = "";

                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_GEB_2_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_GEB_2_ON_FB"
                                  );

                                  const offTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_GEB_2_OFF_FB"
                                  );
                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;
                                  const offValue = onTag
                                    ? Number(offTag["tagValue"])
                                    : 0;

                                  if (
                                    tripValue == 0 &&
                                    onValue == 1 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line-on";
                                  } else if (
                                    tripValue == 1 &&
                                    onValue == 0 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line1";
                                  } else if (
                                    tripValue == 0 &&
                                    onValue == 0 &&
                                    offValue == 1
                                  ) {
                                    appliedClass = "diagonal-line-off";
                                  } else if (
                                    tripValue == 0 &&
                                    onValue == 0 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line-off";
                                  }

                                  return (
                                    <>
                                      <div className={appliedClass}></div>

                                      <div
                                        className="vertical-line"
                                        style={{ top: "-28px" }}
                                      ></div>
                                    </>
                                  );
                                })
                              )}
                          {meterArray.length == 2 &&
                            item.label == "F10 O/G 1250A" &&
                            deviceData
                              .filter((e) => e.id == 383)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == e.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_DG_2_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_DG_2_ON_FB"
                                  );

                                  const offTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_DG_2_OFF_FB"
                                  );
                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;
                                  const offValue = onTag
                                    ? Number(offTag["tagValue"])
                                    : 0;

                                  if (
                                    tripValue == 0 &&
                                    onValue == 1 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line-on";
                                  } else if (
                                    tripValue == 1 &&
                                    onValue == 0 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line1";
                                  } else if (
                                    tripValue == 0 &&
                                    onValue == 0 &&
                                    offValue == 1
                                  ) {
                                    appliedClass = "diagonal-line-off";
                                  } else if (
                                    tripValue == 0 &&
                                    onValue == 0 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line-off";
                                  }

                                  return (
                                    <>
                                      <div className={appliedClass}></div>

                                      <div
                                        className="vertical-line"
                                        style={{ top: "-28px" }}
                                      ></div>
                                    </>
                                  );
                                })
                              )}
                          <img
                            src={lineDesign.dotIcon}
                            alt="dot-icon"
                            className="dot"
                          />
                          {meterArray.length == 1 &&
                            item.label == "F2 O/G 400A" &&
                            deviceData
                              .filter((e) => e.id == 374)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == tags.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let image = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_2F1_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_2F1_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    image = lineDesign.crossRedIcon;
                                  } else if (tripValue == 1 && onValue == 0) {
                                    image = lineDesign.crossIcon;
                                  } else if (tripValue == 0 && onValue == 0) {
                                    image = lineDesign.crossRedIcon;
                                  }

                                  return (
                                    <img src={image} alt="" className="cross" />
                                  );
                                })
                              )}
                          {meterArray.length == 2 &&
                            item.label == "F2 O/G 630A" &&
                            deviceData
                              .filter((e) => e.id == 375)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == tags.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_2F2_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_2F2_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = lineDesign.crossIcon;
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  }

                                  return (
                                    <img
                                      src={appliedClass}
                                      alt=""
                                      className="cross"
                                    />
                                  );
                                })
                              )}

                          {meterArray.length == 1 &&
                            item.label == "F2 O/G 1250A" &&
                            deviceData
                              .filter((e) => e.id == 376)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == tags.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_2F3_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_2F3_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = lineDesign.crossIcon;
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  }

                                  return (
                                    <img
                                      src={appliedClass}
                                      alt=""
                                      className="cross"
                                    />
                                  );
                                })
                              )}
                          {meterArray.length == 2 &&
                            item.label == "F3 O/G 2000A" &&
                            deviceData
                              .filter((e) => e.id == 373)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == tags.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_3F2_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_3F2_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = lineDesign.crossIcon;
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  }

                                  return (
                                    <img
                                      src={appliedClass}
                                      alt=""
                                      className="cross"
                                    />
                                  );
                                })
                              )}

                          {meterArray.length == 1 &&
                            item.label == "F9 O/G 2000A" &&
                            deviceData
                              .filter((e) => e.id == 384)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == tags.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_9F2_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_9F2_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = lineDesign.crossIcon;
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  }

                                  return (
                                    <img
                                      src={appliedClass}
                                      alt=""
                                      className="cross"
                                    />
                                  );
                                })
                              )}

                          {meterArray.length == 2 &&
                            item.label == "F10 O/G 400A" &&
                            deviceData
                              .filter((e) => e.id == 385)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == tags.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_10F1_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_10F1_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = lineDesign.crossIcon;
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  }

                                  return (
                                    <img
                                      src={appliedClass}
                                      alt=""
                                      className="cross"
                                    />
                                  );
                                })
                              )}

                          {meterArray.length == 1 &&
                            item.label == "F10 O/G 630A" &&
                            deviceData
                              .filter((e) => e.id == 386)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == tags.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_10F2_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_10F2_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = lineDesign.crossIcon;
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  }

                                  return (
                                    <img
                                      src={appliedClass}
                                      alt=""
                                      className="cross"
                                    />
                                  );
                                })
                              )}

                          {meterArray.length == 2 &&
                            item.label == "F10 O/G 1250A" &&
                            deviceData
                              .filter((e) => e.id == 387)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == tags.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_10F3_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_10F3_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = lineDesign.crossIcon;
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  }

                                  return (
                                    <img
                                      src={appliedClass}
                                      alt=""
                                      className="cross"
                                    />
                                  );
                                })
                              )}
                          <div className="vertical-line"></div>

                          {meterArray.length == 1 &&
                            item.label == "F2 O/G 400A" &&
                            deviceData
                              .filter((e) => e.id == 374)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let appliedClass = "";

                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_2F1_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_2F1_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = "diagonal-line-off-upward"; // ✅ Case 1
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = "diagonal-line"; // ✅ Case 2
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = "diagonal-line-on-upward";
                                  }
                                  return <div className={appliedClass}></div>;
                                })
                              )}
                          {meterArray.length == 2 &&
                            item.label == "F2 O/G 630A" &&
                            deviceData
                              .filter((e) => e.id == 375)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == tags.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";

                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_2F2_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_2F2_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = "diagonal-line-off-upward"; // ✅ Case 1
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = "diagonal-line"; // ✅ Case 2
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = "diagonal-line-on-upward";
                                  }

                                  return <div className={appliedClass}></div>;
                                })
                              )}
                          {meterArray.length == 1 &&
                            item.label == "F2 O/G 1250A" &&
                            deviceData
                              .filter((e) => e.id == 376)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == tags.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_2F3_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_2F3_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = "diagonal-line-off-upward"; // ✅ Case 1
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = "diagonal-line"; // ✅ Case 2
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = "diagonal-line-on-upward";
                                  }

                                  return <div className={appliedClass}></div>;
                                })
                              )}
                          {meterArray.length == 2 &&
                            item.label == "F3 O/G 2000A" &&
                            deviceData
                              .filter((e) => e.id == 373)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == tags.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_3F2_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_3F2_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = "diagonal-line-off-upward"; // ✅ Case 1
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = "diagonal-line"; // ✅ Case 2
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = "diagonal-line-on-upward";
                                  }

                                  return <div className={appliedClass}></div>;
                                })
                              )}
                          {meterArray.length == 1 &&
                            item.label == "F9 O/G 2000A" &&
                            deviceData
                              .filter((e) => e.id == 384)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == tags.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_9F2_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_9F2_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = "diagonal-line-off-upward"; // ✅ Case 1
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = "diagonal-line"; // ✅ Case 2
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = "diagonal-line-on-upward";
                                  }

                                  return <div className={appliedClass}></div>;
                                })
                              )}
                          {meterArray.length == 2 &&
                            item.label == "F10 O/G 400A" &&
                            deviceData
                              .filter((e) => e.id == 385)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == tags.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";

                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_10F1_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_10F1_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = "diagonal-line-off-upward"; // ✅ Case 1
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = "diagonal-line"; // ✅ Case 2
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = "diagonal-line-on-upward";
                                  }

                                  return <div className={appliedClass}></div>;
                                })
                              )}
                          {meterArray.length == 1 &&
                            item.label == "F10 O/G 630A" &&
                            deviceData
                              .filter((e) => e.id == 386)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == tags.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_10F2_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_10F2_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = "diagonal-line-off-upward"; // ✅ Case 1
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = "diagonal-line"; // ✅ Case 2
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = "diagonal-line-on-upward";
                                  }

                                  return <div className={appliedClass}></div>;
                                })
                              )}
                          {meterArray.length == 2 &&
                            item.label == "F10 O/G 1250A" &&
                            deviceData
                              .filter((e) => e.id == 387)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == tags.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_10F3_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_10F3_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = "diagonal-line-off-upward"; // ✅ Case 1
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = "diagonal-line"; // ✅ Case 2
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = "diagonal-line-on-upward";
                                  }

                                  return <div className={appliedClass}></div>;
                                })
                              )}

                          {item.direction == "upward" ? (
                            <div className="meter-unit">
                              <div className="meter-box">
                                <div className="meter-label">{item.label}</div>
                                <img
                                  src={lineDesign.meterBox}
                                  alt="meter-icon"
                                />
                                <div className="horizontal-line"></div>
                              </div>

                              <div className="meter-info">
                                <div className="meter-values">
                                  {item.label === "F2 O/G 400A" &&
                                    deviceData
                                      .filter((e) => e.id == 374)
                                      .map((e) =>
                                        e.tags.map((tags) => {
                                          let tagValue = mergedArray.length
                                            ? mergedArray.find(
                                                (f) =>
                                                  f.device__uid ==
                                                    e.device__uid &&
                                                  f.device_tag ==
                                                    tags.device_tag
                                              )?.["tagValue"] || 0.0
                                            : 0.0;

                                          if (
                                            tags.is_soft_tag &&
                                            tags.soft_tag_id__formula &&
                                            Object.keys(mqttDataReduce).length
                                          ) {
                                            if (
                                              SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.softTagNotGetTag === true
                                            ) {
                                              tagValue = SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.value;
                                            }
                                          }

                                          if (
                                            [
                                              "V",
                                              "A",
                                              "PF",
                                              "KW",
                                              "KVAR",
                                              "KVA",
                                            ].includes(
                                              tags.tag_unit.toUpperCase()
                                            )
                                          ) {
                                            let label = "";

                                            switch (
                                              tags.tag_unit.toUpperCase()
                                            ) {
                                              case "V":
                                                label = "VLL";
                                                break;
                                              case "A":
                                                label = "LN";
                                                break;
                                              case "PF":
                                                label = "QA";
                                                break;
                                              case "KW":
                                                label = "KT";
                                                break;
                                              case "KVAR":
                                                label = "KV";
                                                break;
                                              case "KVA":
                                                label = "KA";
                                                break;
                                              default:
                                                label = "";
                                            }
                                            return (
                                              <p key={tags.id}>
                                                <span>
                                                  {label} ({tags.tag_unit}):
                                                </span>{" "}
                                                {tagValue}
                                              </p>
                                            );
                                          }

                                          return null;
                                        })
                                      )}
                                  {item.label === "F2 O/G 630A" &&
                                    deviceData
                                      .filter((e) => e.id == 375)
                                      .map((e) =>
                                        e.tags.map((tags) => {
                                          let tagValue = mergedArray.length
                                            ? mergedArray.find(
                                                (f) =>
                                                  f.device__uid ==
                                                    e.device__uid &&
                                                  f.device_tag ==
                                                    tags.device_tag
                                              )?.["tagValue"] || 0.0
                                            : 0.0;

                                          if (
                                            tags.is_soft_tag &&
                                            tags.soft_tag_id__formula &&
                                            Object.keys(mqttDataReduce).length
                                          ) {
                                            if (
                                              SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.softTagNotGetTag === true
                                            ) {
                                              tagValue = SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.value;
                                            }
                                          }

                                          if (
                                            [
                                              "V",
                                              "A",
                                              "PF",
                                              "KW",
                                              "KVAR",
                                              "KVA",
                                            ].includes(
                                              tags.tag_unit.toUpperCase()
                                            )
                                          ) {
                                            let label = "";

                                            switch (
                                              tags.tag_unit.toUpperCase()
                                            ) {
                                              case "V":
                                                label = "VLL";
                                                break;
                                              case "A":
                                                label = "LN";
                                                break;
                                              case "PF":
                                                label = "QA";
                                                break;
                                              case "KW":
                                                label = "KT";
                                                break;
                                              case "KVAR":
                                                label = "KV";
                                                break;
                                              case "KVA":
                                                label = "KA";
                                                break;
                                              default:
                                                label = "";
                                            }
                                            return (
                                              <p key={tags.id}>
                                                <span>
                                                  {label} ({tags.tag_unit}):
                                                </span>{" "}
                                                {tagValue}
                                              </p>
                                            );
                                          }

                                          return null;
                                        })
                                      )}
                                  {item.label === "F2 O/G 1250A" &&
                                    deviceData
                                      .filter((e) => e.id == 376)
                                      .map((e) =>
                                        e.tags.map((tags) => {
                                          let tagValue = mergedArray.length
                                            ? mergedArray.find(
                                                (f) =>
                                                  f.device__uid ==
                                                    e.device__uid &&
                                                  f.device_tag ==
                                                    tags.device_tag
                                              )?.["tagValue"] || 0.0
                                            : 0.0;

                                          if (
                                            tags.is_soft_tag &&
                                            tags.soft_tag_id__formula &&
                                            Object.keys(mqttDataReduce).length
                                          ) {
                                            if (
                                              SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.softTagNotGetTag === true
                                            ) {
                                              tagValue = SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.value;
                                            }
                                          }

                                          if (
                                            [
                                              "V",
                                              "A",
                                              "PF",
                                              "KW",
                                              "KVAR",
                                              "KVA",
                                            ].includes(
                                              tags.tag_unit.toUpperCase()
                                            )
                                          ) {
                                            let label = "";

                                            switch (
                                              tags.tag_unit.toUpperCase()
                                            ) {
                                              case "V":
                                                label = "VLL";
                                                break;
                                              case "A":
                                                label = "LN";
                                                break;
                                              case "PF":
                                                label = "QA";
                                                break;
                                              case "KW":
                                                label = "KT";
                                                break;
                                              case "KVAR":
                                                label = "KV";
                                                break;
                                              case "KVA":
                                                label = "KA";
                                                break;
                                              default:
                                                label = "";
                                            }

                                            return (
                                              <p key={tags.id}>
                                                <span>
                                                  {label} ({tags.tag_unit}):
                                                </span>{" "}
                                                {tagValue}
                                              </p>
                                            );
                                          }

                                          return null;
                                        })
                                      )}
                                  {item.label === "F3 O/G 2000A" &&
                                    deviceData
                                      .filter((e) => e.id == 373)
                                      .map((e) =>
                                        e.tags.map((tags) => {
                                          let tagValue = mergedArray.length
                                            ? mergedArray.find(
                                                (f) =>
                                                  f.device__uid ==
                                                    e.device__uid &&
                                                  f.device_tag ==
                                                    tags.device_tag
                                              )?.["tagValue"] || 0.0
                                            : 0.0;

                                          if (
                                            tags.is_soft_tag &&
                                            tags.soft_tag_id__formula &&
                                            Object.keys(mqttDataReduce).length
                                          ) {
                                            if (
                                              SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.softTagNotGetTag === true
                                            ) {
                                              tagValue = SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.value;
                                            }
                                          }

                                          if (
                                            [
                                              "V",
                                              "A",
                                              "PF",
                                              "KW",
                                              "KVAR",
                                              "KVA",
                                            ].includes(
                                              tags.tag_unit.toUpperCase()
                                            )
                                          ) {
                                            let label = "";

                                            switch (
                                              tags.tag_unit.toUpperCase()
                                            ) {
                                              case "V":
                                                label = "VLL";
                                                break;
                                              case "A":
                                                label = "LN";
                                                break;
                                              case "PF":
                                                label = "QA";
                                                break;
                                              case "KW":
                                                label = "KT";
                                                break;
                                              case "KVAR":
                                                label = "KV";
                                                break;
                                              case "KVA":
                                                label = "KA";
                                                break;
                                              default:
                                                label = "";
                                            }
                                            return (
                                              <p key={tags.id}>
                                                <span>
                                                  {label} ({tags.tag_unit}):
                                                </span>{" "}
                                                {tagValue}
                                              </p>
                                            );
                                          }

                                          return null;
                                        })
                                      )}
                                  {item.label === "F9 O/G 2000A" &&
                                    deviceData
                                      .filter((e) => e.id == 384)
                                      .map((e) =>
                                        e.tags.map((tags) => {
                                          let tagValue = mergedArray.length
                                            ? mergedArray.find(
                                                (f) =>
                                                  f.device__uid ==
                                                    e.device__uid &&
                                                  f.device_tag ==
                                                    tags.device_tag
                                              )?.["tagValue"] || 0.0
                                            : 0.0;

                                          if (
                                            tags.is_soft_tag &&
                                            tags.soft_tag_id__formula &&
                                            Object.keys(mqttDataReduce).length
                                          ) {
                                            if (
                                              SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.softTagNotGetTag === true
                                            ) {
                                              tagValue = SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.value;
                                            }
                                          }

                                          if (
                                            [
                                              "V",
                                              "A",
                                              "PF",
                                              "KW",
                                              "KVAR",
                                              "KVA",
                                            ].includes(
                                              tags.tag_unit.toUpperCase()
                                            )
                                          ) {
                                            let label = "";

                                            switch (
                                              tags.tag_unit.toUpperCase()
                                            ) {
                                              case "V":
                                                label = "VLL";
                                                break;
                                              case "A":
                                                label = "LN";
                                                break;
                                              case "PF":
                                                label = "QA";
                                                break;
                                              case "KW":
                                                label = "KT";
                                                break;
                                              case "KVAR":
                                                label = "KV";
                                                break;
                                              case "KVA":
                                                label = "KA";
                                                break;
                                              default:
                                                label = "";
                                            }

                                            return (
                                              <p key={tags.id}>
                                                <span>
                                                  {label} ({tags.tag_unit}):
                                                </span>{" "}
                                                {tagValue}
                                              </p>
                                            );
                                          }

                                          return null;
                                        })
                                      )}
                                  {item.label === "F10 O/G 400A" &&
                                    deviceData
                                      .filter((e) => e.id == 385)
                                      .map((e) =>
                                        e.tags.map((tags) => {
                                          let tagValue = mergedArray.length
                                            ? mergedArray.find(
                                                (f) =>
                                                  f.device__uid ==
                                                    e.device__uid &&
                                                  f.device_tag ==
                                                    tags.device_tag
                                              )?.["tagValue"] || 0.0
                                            : 0.0;

                                          if (
                                            tags.is_soft_tag &&
                                            tags.soft_tag_id__formula &&
                                            Object.keys(mqttDataReduce).length
                                          ) {
                                            if (
                                              SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.softTagNotGetTag === true
                                            ) {
                                              tagValue = SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.value;
                                            }
                                          }

                                          if (
                                            [
                                              "V",
                                              "A",
                                              "PF",
                                              "KW",
                                              "KVAR",
                                              "KVA",
                                            ].includes(
                                              tags.tag_unit.toUpperCase()
                                            )
                                          ) {
                                            let label = "";

                                            switch (
                                              tags.tag_unit.toUpperCase()
                                            ) {
                                              case "V":
                                                label = "VLL";
                                                break;
                                              case "A":
                                                label = "LN";
                                                break;
                                              case "PF":
                                                label = "QA";
                                                break;
                                              case "KW":
                                                label = "KT";
                                                break;
                                              case "KVAR":
                                                label = "KV";
                                                break;
                                              case "KVA":
                                                label = "KA";
                                                break;
                                              default:
                                                label = "";
                                            }

                                            return (
                                              <p key={tags.id}>
                                                <span>
                                                  {label} ({tags.tag_unit}):
                                                </span>{" "}
                                                {tagValue}
                                              </p>
                                            );
                                          }

                                          return null;
                                        })
                                      )}
                                  {item.label === "F10 O/G 630A" &&
                                    deviceData
                                      .filter((e) => e.id == 386)
                                      .map((e) =>
                                        e.tags.map((tags) => {
                                          let tagValue = mergedArray.length
                                            ? mergedArray.find(
                                                (f) =>
                                                  f.device__uid ==
                                                    e.device__uid &&
                                                  f.device_tag ==
                                                    tags.device_tag
                                              )?.["tagValue"] || 0.0
                                            : 0.0;

                                          if (
                                            tags.is_soft_tag &&
                                            tags.soft_tag_id__formula &&
                                            Object.keys(mqttDataReduce).length
                                          ) {
                                            if (
                                              SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.softTagNotGetTag === true
                                            ) {
                                              tagValue = SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.value;
                                            }
                                          }

                                          if (
                                            [
                                              "V",
                                              "A",
                                              "PF",
                                              "KW",
                                              "KVAR",
                                              "KVA",
                                            ].includes(
                                              tags.tag_unit.toUpperCase()
                                            )
                                          ) {
                                            let label = "";

                                            switch (
                                              tags.tag_unit.toUpperCase()
                                            ) {
                                              case "V":
                                                label = "VLL";
                                                break;
                                              case "A":
                                                label = "LN";
                                                break;
                                              case "PF":
                                                label = "QA";
                                                break;
                                              case "KW":
                                                label = "KT";
                                                break;
                                              case "KVAR":
                                                label = "KV";
                                                break;
                                              case "KVA":
                                                label = "KA";
                                                break;
                                              default:
                                                label = "";
                                            }
                                            return (
                                              <p key={tags.id}>
                                                <span>
                                                  {label} ({tags.tag_unit}):
                                                </span>{" "}
                                                {tagValue}
                                              </p>
                                            );
                                          }

                                          return null;
                                        })
                                      )}
                                  {item.label === "F10 O/G 1250A" &&
                                    deviceData
                                      .filter((e) => e.id == 387)
                                      .map((e) =>
                                        e.tags.map((tags) => {
                                          let tagValue = mergedArray.length
                                            ? mergedArray.find(
                                                (f) =>
                                                  f.device__uid ==
                                                    e.device__uid &&
                                                  f.device_tag ==
                                                    tags.device_tag
                                              )?.["tagValue"] || 0.0
                                            : 0.0;

                                          if (
                                            tags.is_soft_tag &&
                                            tags.soft_tag_id__formula &&
                                            Object.keys(mqttDataReduce).length
                                          ) {
                                            if (
                                              SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.softTagNotGetTag === true
                                            ) {
                                              tagValue = SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.value;
                                            }
                                          }

                                          if (
                                            [
                                              "V",
                                              "A",
                                              "PF",
                                              "KW",
                                              "KVAR",
                                              "KVA",
                                            ].includes(
                                              tags.tag_unit.toUpperCase()
                                            )
                                          ) {
                                            let label = "";

                                            switch (
                                              tags.tag_unit.toUpperCase()
                                            ) {
                                              case "V":
                                                label = "VLL";
                                                break;
                                              case "A":
                                                label = "LN";
                                                break;
                                              case "PF":
                                                label = "QA";
                                                break;
                                              case "KW":
                                                label = "KT";
                                                break;
                                              case "KVAR":
                                                label = "KV";
                                                break;
                                              case "KVA":
                                                label = "KA";
                                                break;
                                              default:
                                                label = "";
                                            }

                                            return (
                                              <p key={tags.id}>
                                                <span>
                                                  {label} ({tags.tag_unit}):
                                                </span>{" "}
                                                {tagValue}
                                              </p>
                                            );
                                          }

                                          return null;
                                        })
                                      )}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="meter-unitData">
                              <div
                                className="vertical-line-to-meter"
                                style={{
                                  height: "187px",
                                  top: "-35px",
                                  left: "unset",
                                  right: "-8px",
                                }}
                              ></div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  flexDirection: "row-reverse",
                                }}
                              >
                                <div
                                  className="meter-box"
                                  style={{
                                    marginRight: "32px",
                                    marginTop: "-137px",
                                  }}
                                >
                                  <div className="meter-label">
                                    {item.label}
                                  </div>
                                  <img
                                    src={lineDesign.meterBox}
                                    alt="meter-icon"
                                  />
                                  <div
                                    className="horizontal-line"
                                    style={{ top: "1px" }}
                                  ></div>
                                </div>
                                <div
                                  className="meter-info"
                                  style={{ marginTop: "-10px" }}
                                >
                                  <div
                                    style={{ marginTop: "-10px" }}
                                    className={
                                      item.label !== "DG-1"
                                        ? "meter-values"
                                        : "meter-values "
                                    }
                                  >
                                    {item.label === "DG-1" &&
                                      deviceData
                                        .filter((e) => e.id == 372)
                                        .map((e) =>
                                          e.tags.map((tags) => {
                                            let tagValue = mergedArray.length
                                              ? mergedArray.find(
                                                  (f) =>
                                                    f.device__uid ==
                                                      tags.device__uid &&
                                                    f.device_tag ==
                                                      tags.device_tag
                                                )?.["tagValue"] || 0.0
                                              : 0.0;

                                            if (
                                              tags.is_soft_tag &&
                                              tags.soft_tag_id__formula &&
                                              Object.keys(mqttDataReduce).length
                                            ) {
                                              if (
                                                SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.softTagNotGetTag === true
                                              ) {
                                                tagValue = SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.value;
                                              }
                                            }

                                            if (
                                              [
                                                "V",
                                                "A",
                                                "PF",
                                                "KW",
                                                "KVAR",
                                                "KVA",
                                              ].includes(
                                                tags.tag_unit.toUpperCase()
                                              )
                                            ) {
                                              let label = "";

                                              switch (
                                                tags.tag_unit.toUpperCase()
                                              ) {
                                                case "V":
                                                  label = "VLL";
                                                  break;
                                                case "A":
                                                  label = "LN";
                                                  break;
                                                case "PF":
                                                  label = "QA";
                                                  break;
                                                case "KW":
                                                  label = "KT";
                                                  break;
                                                case "KVAR":
                                                  label = "KV";
                                                  break;
                                                case "KVA":
                                                  label = "KA";
                                                  break;
                                                default:
                                                  label = "";
                                              }

                                              return (
                                                <p key={tags.id}>
                                                  <span>
                                                    {label} ({tags.tag_unit}):
                                                  </span>{" "}
                                                  {tagValue}
                                                </p>
                                              );
                                            }

                                            return null;
                                          })
                                        )}

                                    {item.label === "GEB-1" &&
                                      deviceData
                                        .filter((e) => e.id == 371)
                                        .map((e) =>
                                          e.tags.map((tags) => {
                                            let tagValue = mergedArray.length
                                              ? mergedArray.find(
                                                  (f) =>
                                                    f.device__uid ==
                                                      e.device__uid &&
                                                    f.device_tag ==
                                                      tags.device_tag
                                                )?.["tagValue"] || 0.0
                                              : 0.0;

                                            if (
                                              tags.is_soft_tag &&
                                              tags.soft_tag_id__formula &&
                                              Object.keys(mqttDataReduce).length
                                            ) {
                                              if (
                                                SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.softTagNotGetTag === true
                                              ) {
                                                tagValue = SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.value;
                                              }
                                            }

                                            if (
                                              [
                                                "V",
                                                "A",
                                                "PF",
                                                "KW",
                                                "KVAR",
                                                "KVA",
                                              ].includes(
                                                tags.tag_unit.toUpperCase()
                                              )
                                            ) {
                                              let label = "";

                                              switch (
                                                tags.tag_unit.toUpperCase()
                                              ) {
                                                case "V":
                                                  label = "VLL";
                                                  break;
                                                case "A":
                                                  label = "LN";
                                                  break;
                                                case "PF":
                                                  label = "QA";
                                                  break;
                                                case "KW":
                                                  label = "KT";
                                                  break;
                                                case "KVAR":
                                                  label = "KV";
                                                  break;
                                                case "KVA":
                                                  label = "KA";
                                                  break;
                                                default:
                                                  label = "";
                                              }

                                              return (
                                                <p key={tags.id}>
                                                  <span>
                                                    {label} ({tags.tag_unit}):
                                                  </span>{" "}
                                                  {tagValue}
                                                </p>
                                              );
                                            }

                                            return null;
                                          })
                                        )}
                                    {item.label === "GEB-2" &&
                                      deviceData
                                        .filter((e) => e.id == 382)
                                        .map((e) =>
                                          e.tags.map((tags) => {
                                            let tagValue = mergedArray.length
                                              ? mergedArray.find(
                                                  (f) =>
                                                    f.device__uid ==
                                                      e.device__uid &&
                                                    f.device_tag ==
                                                      tags.device_tag
                                                )?.["tagValue"] || 0.0
                                              : 0.0;

                                            if (
                                              tags.is_soft_tag &&
                                              tags.soft_tag_id__formula &&
                                              Object.keys(mqttDataReduce).length
                                            ) {
                                              if (
                                                SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.softTagNotGetTag === true
                                              ) {
                                                tagValue = SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.value;
                                              }
                                            }

                                            if (
                                              [
                                                "V",
                                                "A",
                                                "PF",
                                                "KW",
                                                "KVAR",
                                                "KVA",
                                              ].includes(
                                                tags.tag_unit.toUpperCase()
                                              )
                                            ) {
                                              let label = "";

                                              switch (
                                                tags.tag_unit.toUpperCase()
                                              ) {
                                                case "V":
                                                  label = "VLL";
                                                  break;
                                                case "A":
                                                  label = "LN";
                                                  break;
                                                case "PF":
                                                  label = "QA";
                                                  break;
                                                case "KW":
                                                  label = "KT";
                                                  break;
                                                case "KVAR":
                                                  label = "KV";
                                                  break;
                                                case "KVA":
                                                  label = "KA";
                                                  break;
                                                default:
                                                  label = "";
                                              }
                                              return (
                                                <p key={tags.id}>
                                                  <span>
                                                    {label} ({tags.tag_unit}):
                                                  </span>{" "}
                                                  {tagValue}
                                                </p>
                                              );
                                            }

                                            return null;
                                          })
                                        )}
                                    {item.label === "DG-2" &&
                                      deviceData
                                        .filter((e) => e.id == 383)
                                        .map((e) =>
                                          e.tags.map((tags) => {
                                            let tagValue = mergedArray.length
                                              ? mergedArray.find(
                                                  (f) =>
                                                    f.device__uid ==
                                                      e.device__uid &&
                                                    f.device_tag ==
                                                      tags.device_tag
                                                )?.["tagValue"] || 0.0
                                              : 0.0;

                                            if (
                                              tags.is_soft_tag &&
                                              tags.soft_tag_id__formula &&
                                              Object.keys(mqttDataReduce).length
                                            ) {
                                              if (
                                                SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.softTagNotGetTag === true
                                              ) {
                                                tagValue = SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.value;
                                              }
                                            }

                                            if (
                                              [
                                                "V",
                                                "A",
                                                "PF",
                                                "KW",
                                                "KVAR",
                                                "KVA",
                                              ].includes(
                                                tags.tag_unit.toUpperCase()
                                              )
                                            ) {
                                              let label = "";

                                              switch (
                                                tags.tag_unit.toUpperCase()
                                              ) {
                                                case "V":
                                                  label = "VLL";
                                                  break;
                                                case "A":
                                                  label = "LN";
                                                  break;
                                                case "PF":
                                                  label = "QA";
                                                  break;
                                                case "KW":
                                                  label = "KT";
                                                  break;
                                                case "KVAR":
                                                  label = "KV";
                                                  break;
                                                case "KVA":
                                                  label = "KA";
                                                  break;
                                                default:
                                                  label = "";
                                              }

                                              return (
                                                <p key={tags.id}>
                                                  <span>
                                                    {label} ({tags.tag_unit}):
                                                  </span>{" "}
                                                  {tagValue}
                                                </p>
                                              );
                                            }

                                            return null;
                                          })
                                        )}
                                  </div>
                                </div>
                              </div>

                              {deviceData
                                .filter((e) => e.id == 372)
                                .map((e) =>
                                  e.tags.map((tags) => {
                                    let tagValue = mergedArray.length
                                      ? mergedArray.find(
                                          (f) =>
                                            f.device__uid == e.device__uid &&
                                            f.device_tag == tags.device_tag
                                        )?.["tagValue"] || 0.0
                                      : 0.0;
                                    let appliedClass = "";
                                    const tripTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == "P_DG_1_TRIP_FB"
                                    );
                                    const onTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid === tags.device__uid &&
                                        f.device_tag == "P_DG_1_ON_FB"
                                    );
                                    const offTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid === tags.device__uid &&
                                        f.device_tag == "P_DG_1_OFF_FB"
                                    );

                                    const tripValue = tripTag
                                      ? Number(tripTag["tagValue"])
                                      : 0;
                                    const onValue = onTag
                                      ? Number(onTag["tagValue"])
                                      : 0;
                                    const offValue = offTag
                                      ? Number(offTag["tagValue"])
                                      : 0;

                                    if (
                                      tripValue == 0 &&
                                      onValue == 1 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    } else if (
                                      tripValue == 1 &&
                                      onValue == 0 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossIcon;
                                    } else if (
                                      tripValue == 0 &&
                                      onValue == 0 &&
                                      offValue == 1
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    } else if (
                                      tripValue == 0 &&
                                      onValue == 0 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    }

                                    return (
                                      <>
                                        <img
                                          src={appliedClass}
                                          alt=""
                                          className="cross"
                                          style={{
                                            top: "140px",
                                            left: "unset",
                                            right: "-22px",
                                          }}
                                        />
                                      </>
                                    );
                                  })
                                )}
                              {deviceData
                                .filter((e) => e.id == 371)
                                .map((e) =>
                                  e.tags.map((tags) => {
                                    let tagValue = mergedArray.length
                                      ? mergedArray.find(
                                          (f) =>
                                            f.device__uid == e.device__uid &&
                                            f.device_tag == tags.device_tag
                                        )?.["tagValue"] || 0.0
                                      : 0.0;
                                    let appliedClass = "";
                                    const tripTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == "P_GEB_1_TRIP_FB"
                                    );
                                    const onTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid === tags.device__uid &&
                                        f.device_tag == "P_GEB_1_ON_FB"
                                    );
                                    const offTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid === tags.device__uid &&
                                        f.device_tag == "P_GEB_1_OFF_FB"
                                    );

                                    const tripValue = tripTag
                                      ? Number(tripTag["tagValue"])
                                      : 0;
                                    const onValue = onTag
                                      ? Number(onTag["tagValue"])
                                      : 0;
                                    const offValue = offTag
                                      ? Number(offTag["tagValue"])
                                      : 0;

                                    if (
                                      tripValue == 0 &&
                                      onValue == 1 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    } else if (
                                      tripValue == 1 &&
                                      onValue == 0 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossIcon;
                                    } else if (
                                      tripValue == 0 &&
                                      onValue == 0 &&
                                      offValue == 1
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    } else if (
                                      tripValue == 0 &&
                                      onValue == 0 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    }

                                    return (
                                      <>
                                        <img
                                          src={appliedClass}
                                          alt=""
                                          className="cross"
                                          style={{
                                            top: "140px",
                                            left: "unset",
                                            right: "-22px",
                                          }}
                                        />
                                      </>
                                    );
                                  })
                                )}
                              {deviceData
                                .filter((e) => e.id == 382)
                                .map((e) =>
                                  e.tags.map((tags) => {
                                    let tagValue = mergedArray.length
                                      ? mergedArray.find(
                                          (f) =>
                                            f.device__uid == e.device__uid &&
                                            f.device_tag == tags.device_tag
                                        )?.["tagValue"] || 0.0
                                      : 0.0;

                                    let appliedClass = "";
                                    const tripTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == "P_GEB_2_TRIP_FB"
                                    );
                                    const onTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid === tags.device__uid &&
                                        f.device_tag == "P_GEB_2_ON_FB"
                                    );
                                    const offTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid === tags.device__uid &&
                                        f.device_tag == "P_GEB_2_OFF_FB"
                                    );

                                    const tripValue = tripTag
                                      ? Number(tripTag["tagValue"])
                                      : 0;
                                    const onValue = onTag
                                      ? Number(onTag["tagValue"])
                                      : 0;
                                    const offValue = offTag
                                      ? Number(offTag["tagValue"])
                                      : 0;

                                    if (
                                      tripValue == 0 &&
                                      onValue == 1 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    } else if (
                                      tripValue == 1 &&
                                      onValue == 0 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossIcon;
                                    } else if (
                                      tripValue == 0 &&
                                      onValue == 0 &&
                                      offValue == 1
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    } else if (
                                      tripValue == 0 &&
                                      onValue == 0 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    }

                                    return (
                                      <>
                                        <img
                                          src={appliedClass}
                                          alt=""
                                          className="cross"
                                          style={{
                                            top: "140px",
                                            left: "unset",
                                            right: "-22px",
                                          }}
                                        />
                                      </>
                                    );
                                  })
                                )}
                              {deviceData
                                .filter((e) => e.id == 383)
                                .map((e) =>
                                  e.tags.map((tags) => {
                                    let tagValue = mergedArray.length
                                      ? mergedArray.find(
                                          (f) =>
                                            f.device__uid == e.device__uid &&
                                            f.device_tag == tags.device_tag
                                        )?.["tagValue"] || 0.0
                                      : 0.0;

                                    let appliedClass = "";
                                    const tripTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == "P_DG_2_TRIP_FB"
                                    );
                                    const onTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid === tags.device__uid &&
                                        f.device_tag == "P_DG_2_ON_FB"
                                    );
                                    const offTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid === tags.device__uid &&
                                        f.device_tag == "P_DG_2_OFF_FB"
                                    );

                                    const tripValue = tripTag
                                      ? Number(tripTag["tagValue"])
                                      : 0;
                                    const onValue = onTag
                                      ? Number(onTag["tagValue"])
                                      : 0;
                                    const offValue = offTag
                                      ? Number(offTag["tagValue"])
                                      : 0;

                                    if (
                                      tripValue == 0 &&
                                      onValue == 1 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    } else if (
                                      tripValue == 1 &&
                                      onValue == 0 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossIcon;
                                    } else if (
                                      tripValue == 0 &&
                                      onValue == 0 &&
                                      offValue == 1
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    } else if (
                                      tripValue == 0 &&
                                      onValue == 0 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    }

                                    return (
                                      <>
                                        <img
                                          src={appliedClass}
                                          alt=""
                                          className="cross"
                                          style={{
                                            top: "140px",
                                            left: "unset",
                                            right: "-22px",
                                          }}
                                        />
                                      </>
                                    );
                                  })
                                )}
                            </div>
                          )}

                          <div className="vertical-line-to-meter"></div>
                        </React.Fragment>
                      ))}
                    </div>
                  );
                })}
              </div>
            </>
          )}

          {activePage !== 2 && (
            <img
              src={lineDesign.rightArrowIcon}
              alt="right-arrow"
              className="right-arrow"
              onClick={() => handleNextClick()}
            />
          )}
          {activePage == 2 && (
            <div className="busbar2">
              {meters1.map((meter, index) => (
                <div key={index} className="connection-point">
                  <img
                    src={lineDesign.dotIcon}
                    alt="dot-icon"
                    className="dot"
                  />
                  <div className="vertical-line"></div>
                  {meter.label == "F11 O/G 100A" &&
                    deviceData
                      .filter((e) => e.id == 388)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                                (f) =>
                                  f.device__uid == tags.device__uid &&
                                  f.device_tag == tags.device_tag
                              )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_11F2_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_11F2_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = lineDesign.crossRedIcon;
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = lineDesign.crossIcon;
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = lineDesign.crossRedIcon;
                          }

                          return (
                            <img src={appliedClass} alt="" className="cross" />
                          );
                        })
                      )}
                  {meter.label == "F11 O/G 125A" &&
                    meter.id == 2 &&
                    deviceData
                      .filter((e) => e.id == 389)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                                (f) =>
                                  f.device__uid == tags.device__uid &&
                                  f.device_tag == tags.device_tag
                              )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_11F3_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_11F3_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = lineDesign.crossRedIcon;
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = lineDesign.crossIcon;
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = lineDesign.crossRedIcon;
                          }

                          return (
                            <img src={appliedClass} alt="" className="cross" />
                          );
                        })
                      )}

                  {meter.label == "F11 O/G 125A" &&
                    meter.id == 3 &&
                    deviceData
                      .filter((e) => e.id == 390)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                                (f) =>
                                  f.device__uid == tags.device__uid &&
                                  f.device_tag == tags.device_tag
                              )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_11F4_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_11F4_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = lineDesign.crossRedIcon;
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = lineDesign.crossIcon;
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = lineDesign.crossRedIcon;
                          }

                          return (
                            <img src={appliedClass} alt="" className="cross" />
                          );
                        })
                      )}

                  {meter.label == "F11 O/G 200A" &&
                    deviceData
                      .filter((e) => e.id == 391)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                                (f) =>
                                  f.device__uid == tags.device__uid &&
                                  f.device_tag == tags.device_tag
                              )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_11F5_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_11F5_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = lineDesign.crossRedIcon;
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = lineDesign.crossIcon;
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = lineDesign.crossRedIcon;
                          }

                          return (
                            <img src={appliedClass} alt="" className="cross" />
                          );
                        })
                      )}
                  {meter.label == "F11 O/G 100A" &&
                    deviceData
                      .filter((e) => e.id == 388)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                                (f) =>
                                  f.device__uid == tags.device__uid &&
                                  f.device_tag == tags.device_tag
                              )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_11F2_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_11F2_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = "diagonal-line-off-upward";
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = "diagonal-line";
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = "diagonal-line-green";
                          }

                          return <div className={appliedClass}></div>;
                        })
                      )}
                  {meter.label == "F11 O/G 125A" &&
                    meter.id == 2 &&
                    deviceData
                      .filter((e) => e.id == 389)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                                (f) =>
                                  f.device__uid == tags.device__uid &&
                                  f.device_tag == tags.device_tag
                              )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_11F3_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_11F3_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = "diagonal-line-off-upward";
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = "diagonal-line";
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = "diagonal-line-green";
                          }

                          return <div className={appliedClass}></div>;
                        })
                      )}
                  {meter.label == "F11 O/G 125A" &&
                    meter.id == 3 &&
                    deviceData
                      .filter((e) => e.id == 390)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                                (f) =>
                                  f.device__uid == tags.device__uid &&
                                  f.device_tag == tags.device_tag
                              )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_11F4_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_11F4_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = "diagonal-line-off-upward";
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = "diagonal-line";
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = "diagonal-line-green";
                          }

                          return <div className={appliedClass}></div>;
                        })
                      )}
                  {meter.label == "F11 O/G 200A" &&
                    deviceData
                      .filter((e) => e.id == 391)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                                (f) =>
                                  f.device__uid == tags.device__uid &&
                                  f.device_tag == tags.device_tag
                              )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_11F5_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_11F5_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = "diagonal-line-off-upward";
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = "diagonal-line";
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = "diagonal-line-green";
                          }

                          return <div className={appliedClass}></div>;
                        })
                      )}
                  {/* <div className="diagonal-line"></div> */}
                  <div className="meter-unit">
                    <div className="meter-box">
                      <div className="meter-label">{meter.label}</div>
                      <img src={lineDesign.meterBox} alt="meter-icon" />
                      <div className="horizontal-line"></div>
                    </div>
                    <div className="meter-info">
                      <div className="meter-values">
                        {/* {meter.label === "F1 O/G 100A" &&
                          deviceData
                            .filter((e) => e.id == 377)
                            .map((e) =>
                              e.tags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                  : 0.0;

                                if (
                                  tags.is_soft_tag &&
                                  tags.soft_tag_id__formula &&
                                  Object.keys(mqttDataReduce).length
                                ) {
                                  if (
                                    SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag === true
                                  ) {
                                    tagValue = SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.value;
                                  }
                                }

                                if (
                                  [
                                    "V",
                                    "A",
                                    "PF",
                                    "KW",
                                    "KVAR",
                                    "KVA",
                                  ].includes(tags.tag_unit.toUpperCase())
                                ) {
                                  let label = "";

                                  switch (tags.tag_unit.toUpperCase()) {
                                    case "V":
                                      label = "VLL";
                                      break;
                                    case "A":
                                      label = "LN";
                                      break;
                                    case "PF":
                                      label = "QA";
                                      break;
                                    case "KW":
                                      label = "KT";
                                      break;
                                    case "KVAR":
                                      label = "KV";
                                      break;
                                    case "KVA":
                                      label = "KA";
                                      break;
                                    default:
                                      label = "";
                                  }
                                  return (
                                    <p key={tags.id}>
                                      <span>
                                        {label} ({tags.tag_unit}):
                                      </span>{" "}
                                      {tagValue}
                                    </p>
                                  );
                                }

                                return null;
                              })
                            )}
                        {meter.label === "F1 O/G 125A" &&
                          deviceData
                            .filter((e) => e.id == 378)
                            .map((e) =>
                              e.tags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                  : 0.0;

                                if (
                                  tags.is_soft_tag &&
                                  tags.soft_tag_id__formula &&
                                  Object.keys(mqttDataReduce).length
                                ) {
                                  if (
                                    SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag === true
                                  ) {
                                    tagValue = SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.value;
                                  }
                                }

                                if (
                                  [
                                    "V",
                                    "A",
                                    "PF",
                                    "KW",
                                    "KVAR",
                                    "KVA",
                                  ].includes(tags.tag_unit.toUpperCase())
                                ) {
                                  let label = "";

                                  switch (tags.tag_unit.toUpperCase()) {
                                    case "V":
                                      label = "VLL";
                                      break;
                                    case "A":
                                      label = "LN";
                                      break;
                                    case "PF":
                                      label = "QA";
                                      break;
                                    case "KW":
                                      label = "KT";
                                      break;
                                    case "KVAR":
                                      label = "KV";
                                      break;
                                    case "KVA":
                                      label = "KA";
                                      break;
                                    default:
                                      label = "";
                                  }

                                  return (
                                    <p key={tags.id}>
                                      <span>
                                        {label} ({tags.tag_unit}):
                                      </span>{" "}
                                      {tagValue}
                                    </p>
                                  );
                                }

                                return null;
                              })
                            )}
                        {meter.label === "F1 O/G 125A" &&
                          deviceData
                            .filter((e) => e.id == 379)
                            .map((e) =>
                              e.tags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                  : 0.0;

                                if (
                                  tags.is_soft_tag &&
                                  tags.soft_tag_id__formula &&
                                  Object.keys(mqttDataReduce).length
                                ) {
                                  if (
                                    SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag === true
                                  ) {
                                    tagValue = SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.value;
                                  }
                                }

                                if (
                                  [
                                    "V",
                                    "A",
                                    "PF",
                                    "KW",
                                    "KVAR",
                                    "KVA",
                                  ].includes(tags.tag_unit.toUpperCase())
                                ) {
                                  let label = "";

                                  switch (tags.tag_unit.toUpperCase()) {
                                    case "V":
                                      label = "VLL";
                                      break;
                                    case "A":
                                      label = "LN";
                                      break;
                                    case "PF":
                                      label = "QA";
                                      break;
                                    case "KW":
                                      label = "KT";
                                      break;
                                    case "KVAR":
                                      label = "KV";
                                      break;
                                    case "KVA":
                                      label = "KA";
                                      break;
                                    default:
                                      label = "";
                                  }

                                  return (
                                    <p key={tags.id}>
                                      <span>
                                        {label} ({tags.tag_unit}):
                                      </span>{" "}
                                      {tagValue}
                                    </p>
                                  );
                                }

                                return null;
                              })
                            )} */}
                        {meter.label === "F11 O/G 100A" &&
                          deviceData
                            .filter((e) => e.id == 388)
                            .map((e) =>
                              e.tags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                  : 0.0;

                                if (
                                  tags.is_soft_tag &&
                                  tags.soft_tag_id__formula &&
                                  Object.keys(mqttDataReduce).length
                                ) {
                                  if (
                                    SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag === true
                                  ) {
                                    tagValue = SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.value;
                                  }
                                }

                                if (
                                  [
                                    "V",
                                    "A",
                                    "PF",
                                    "KW",
                                    "KVAR",
                                    "KVA",
                                  ].includes(tags.tag_unit.toUpperCase())
                                ) {
                                  let label = "";

                                  switch (tags.tag_unit.toUpperCase()) {
                                    case "V":
                                      label = "VLL";
                                      break;
                                    case "A":
                                      label = "LN";
                                      break;
                                    case "PF":
                                      label = "QA";
                                      break;
                                    case "KW":
                                      label = "KT";
                                      break;
                                    case "KVAR":
                                      label = "KV";
                                      break;
                                    case "KVA":
                                      label = "KA";
                                      break;
                                    default:
                                      label = "";
                                  }
                                  return (
                                    <p key={tags.id}>
                                      <span>
                                        {label} ({tags.tag_unit}):
                                      </span>{" "}
                                      {tagValue}
                                    </p>
                                  );
                                }

                                return null;
                              })
                            )}
                        {/* {meter.label === "F1 O/G 200A" &&
                          deviceData
                            .filter((e) => e.id == 389)
                            .map((e) =>
                              e.tags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                  : 0.0;

                                if (
                                  tags.is_soft_tag &&
                                  tags.soft_tag_id__formula &&
                                  Object.keys(mqttDataReduce).length
                                ) {
                                  if (
                                    SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag === true
                                  ) {
                                    tagValue = SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.value;
                                  }
                                }

                                if (
                                  [
                                    "V",
                                    "A",
                                    "PF",
                                    "KW",
                                    "KVAR",
                                    "KVA",
                                  ].includes(tags.tag_unit.toUpperCase())
                                ) {
                                  let label = "";

                                  switch (tags.tag_unit.toUpperCase()) {
                                    case "V":
                                      label = "VLL";
                                      break;
                                    case "A":
                                      label = "LN";
                                      break;
                                    case "PF":
                                      label = "QA";
                                      break;
                                    case "KW":
                                      label = "KT";
                                      break;
                                    case "KVAR":
                                      label = "KV";
                                      break;
                                    case "KVA":
                                      label = "KA";
                                      break;
                                    default:
                                      label = "";
                                  }
                                  return (
                                    <p key={tags.id}>
                                      <span>
                                        {label} ({tags.tag_unit}):
                                      </span>{" "}
                                      {tagValue}
                                    </p>
                                  );
                                }

                                return null;
                              })
                            )} */}
                        {meter.label === "F11 O/G 125A" && meter.id == 2 &&
                          deviceData
                            .filter((e) => e.id == 389)
                            .map((e) =>
                              e.tags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                  : 0.0;

                                if (
                                  tags.is_soft_tag &&
                                  tags.soft_tag_id__formula &&
                                  Object.keys(mqttDataReduce).length
                                ) {
                                  if (
                                    SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag === true
                                  ) {
                                    tagValue = SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.value;
                                  }
                                }

                                if (
                                  [
                                    "V",
                                    "A",
                                    "PF",
                                    "KW",
                                    "KVAR",
                                    "KVA",
                                  ].includes(tags.tag_unit.toUpperCase())
                                ) {
                                  let label = "";

                                  switch (tags.tag_unit.toUpperCase()) {
                                    case "V":
                                      label = "VLL";
                                      break;
                                    case "A":
                                      label = "LN";
                                      break;
                                    case "PF":
                                      label = "QA";
                                      break;
                                    case "KW":
                                      label = "KT";
                                      break;
                                    case "KVAR":
                                      label = "KV";
                                      break;
                                    case "KVA":
                                      label = "KA";
                                      break;
                                    default:
                                      label = "";
                                  }
                                  return (
                                    <p key={tags.id}>
                                      <span>
                                        {label} ({tags.tag_unit}):
                                      </span>{" "}
                                      {tagValue}
                                    </p>
                                  );
                                }

                                return null;
                              })
                            )}
                     {meter.label === "F11 O/G 125A" && meter.id == 3 &&
                          deviceData
                            .filter((e) => e.id == 390)
                            .map((e) =>
                              e.tags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                  : 0.0;

                                if (
                                  tags.is_soft_tag &&
                                  tags.soft_tag_id__formula &&
                                  Object.keys(mqttDataReduce).length
                                ) {
                                  if (
                                    SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag === true
                                  ) {
                                    tagValue = SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.value;
                                  }
                                }

                                if (
                                  [
                                    "V",
                                    "A",
                                    "PF",
                                    "KW",
                                    "KVAR",
                                    "KVA",
                                  ].includes(tags.tag_unit.toUpperCase())
                                ) {
                                  let label = "";

                                  switch (tags.tag_unit.toUpperCase()) {
                                    case "V":
                                      label = "VLL";
                                      break;
                                    case "A":
                                      label = "LN";
                                      break;
                                    case "PF":
                                      label = "QA";
                                      break;
                                    case "KW":
                                      label = "KT";
                                      break;
                                    case "KVAR":
                                      label = "KV";
                                      break;
                                    case "KVA":
                                      label = "KA";
                                      break;
                                    default:
                                      label = "";
                                  }
                                  return (
                                    <p key={tags.id}>
                                      <span>
                                        {label} ({tags.tag_unit}):
                                      </span>{" "}
                                      {tagValue}
                                    </p>
                                  );
                                }

                                return null;
                              })
                            )}
                           {meter.label === "F11 O/G 200A" &&
                          deviceData
                            .filter((e) => e.id == 391)
                            .map((e) =>
                              e.tags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                  : 0.0;

                                if (
                                  tags.is_soft_tag &&
                                  tags.soft_tag_id__formula &&
                                  Object.keys(mqttDataReduce).length
                                ) {
                                  if (
                                    SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag === true
                                  ) {
                                    tagValue = SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.value;
                                  }
                                }

                                if (
                                  [
                                    "V",
                                    "A",
                                    "PF",
                                    "KW",
                                    "KVAR",
                                    "KVA",
                                  ].includes(tags.tag_unit.toUpperCase())
                                ) {
                                  let label = "";

                                  switch (tags.tag_unit.toUpperCase()) {
                                    case "V":
                                      label = "VLL";
                                      break;
                                    case "A":
                                      label = "LN";
                                      break;
                                    case "PF":
                                      label = "QA";
                                      break;
                                    case "KW":
                                      label = "KT";
                                      break;
                                    case "KVAR":
                                      label = "KV";
                                      break;
                                    case "KVA":
                                      label = "KA";
                                      break;
                                    default:
                                      label = "";
                                  }

                                  return (
                                    <p key={tags.id}>
                                      <span>
                                        {label} ({tags.tag_unit}):
                                      </span>{" "}
                                      {tagValue}
                                    </p>
                                  );
                                }

                                return null;
                              })
                            )}
                      </div>
                    </div>
                  </div>
                  <div className="vertical-line-to-meter"></div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default LineDesign;